import React from 'react';
import { compose } from 'redux';
import { withTranslation, WithTranslation } from 'react-i18next';
import TallExhibitionist from './TallExhibitionist';
import ExhibitionistBox, {
  ExhibitionistBoxProps,
  ExhibitionistBoxType,
} from '../_partials/ExhibitionistBox';
import ExhibitionistEmptyState from '../_partials/ExhibitionistEmptyState';
import FavouritesLabel from '../_partials/FavouritesLabel';
import { withModuleData, WithModuleData } from '../_hoc/withModuleData';
import { GallectionType } from '../../../../types/gallection';

import s from './TallExhibitionist.scss';

const enhance = compose(
  withModuleData,
  withTranslation()
);
class TallExhibitionistBox extends React.Component<
  ExhibitionistBoxProps & WithTranslation & WithModuleData
> {
  render() {
    return (
      <ExhibitionistBox
        {...this.props}
        headerExtras={this.renderHeaderExtras()}
        exhibitionistType={ExhibitionistBoxType.TALL}
        emptyView={
          <ExhibitionistEmptyState
            moduleId={this.props.moduleId}
            view="small"
            className={s['empty-state']}
            exhibitionistType={ExhibitionistBoxType.TALL}
          />
        }
      >
        {boxProps => <TallExhibitionist {...boxProps} />}
      </ExhibitionistBox>
    );
  }

  renderHeaderExtras() {
    const {
      moduleData: { sourceType },
    } = this.props;
    if (sourceType === GallectionType.COLLECTION) {
      return <FavouritesLabel />;
    }
  }
}

export default enhance(TallExhibitionistBox) as React.ComponentType<{}>;
